import {computed} from 'vue';
import {APP_PROMO_LIVE} from '@/common/config/appPromo';
import {StorageKeys} from '@/common/enums/StorageKeys';
import {useStore} from '@/common/store/store';

/**
 * Wer den App-Hinweis zu sehen bekommt und ob der Dialog in dieser Session
 * schon durch ist. Dialog und Footer-Verweis teilen sich die Regel — stünde sie
 * zweimal da, würde die eine Hälfte irgendwann ohne die andere geändert.
 */
export function useAppPromo() {
  const store = useStore();

  // The app is the client app. Admins and coaches have nothing to do with it —
  // and a coach who slipped into a client account via user switch is still the
  // coach, where `isAdmin` already reads false. Hence both checks.
  const promoVisible = computed(() => APP_PROMO_LIVE && !store.isAdmin && store.userData?.user_switch_name === undefined);

  // Per browser session, not forever: the dialog is a one-off nudge, but
  // somebody who waves it away today should meet it again next time rather than
  // never. sessionStorage does that without asking the server to remember.
  const dialogSeen = (): boolean => {
    return sessionStorage.getItem(StorageKeys.APP_PROMO_SEEN) === '1';
  };

  const markDialogSeen = (): void => {
    sessionStorage.setItem(StorageKeys.APP_PROMO_SEEN, '1');
  };

  return {promoVisible, dialogSeen, markDialogSeen};
}
